import {
  type EEnrollmentStatus,
  useGetApiV1CourseregistrationSharedStatusReasonList,
} from '@/shared/api/generated';

export interface StatusReasonOption {
  readonly id: string;
  readonly name: string;
}

/**
 * Lista de motivos de status (cancelamento, rejeição, bloqueio, etc.) já
 * filtrada pelo backend conforme o status alvo passado em {@link status}.
 *
 * @param status - Status alvo da transição (codificado conforme `EEnrollmentStatus`).
 *                 Quando omitido, a query é desabilitada.
 */
export function useStatusReasons(status?: EEnrollmentStatus) {
  const query = useGetApiV1CourseregistrationSharedStatusReasonList(
    status !== undefined ? { status } : undefined,
    { query: { enabled: status !== undefined } },
  );

  const reasons: readonly StatusReasonOption[] = (query.data ?? []).map(item => ({
    id: String(item.key ?? ''),
    name: item.value ?? '',
  }));

  return {
    reasons,
    isLoading: query.isLoading,
    isError: query.isError,
  } as const;
}
